import config from '@/../vue.config'


// Divide a string da url
let fullUrl = window.location.host
// eslint-disable-next-line
let strArr = fullUrl.split('.')
let apiUrl = process.env.VUE_APP_API_URL || null
let apiUrlMicro = process.env.VUE_APP_API_MICROSERVICE || null
let devHost = process.env.NODE_ENV === 'development'
let urlInstance = strArr[0]

if (devHost && apiUrl != null) {
    apiUrl = 'http://' + apiUrl + ':' + process.env.VUE_APP_DEV_PORTAINER_PORT
}

if (!apiUrl) {
    if (strArr.length == 3) {
        apiUrl = strArr[1] == 'facilitavendas' ?
            'https://' + strArr[0] + '.api.' + strArr.slice(1).join('.') :
            'https://' + strArr[0] + '.api.' + strArr.join('.')
    
    } else {
        if (strArr[3] == 'local') {
            apiUrl = 'http://sistema.' + strArr.slice(1).join('.')
        } else {
            apiUrl = 'https://' + strArr[0] + '.api.' + strArr.slice(1).join('.')
        }
    }
}

export const facilita = {
    gstoken : '518c2b22e9372a2e8bd0cda98b14e21d',
    panel   : '/',
    instance: urlInstance || process.env.VUE_APP_INSTANCE,
    oauthUrl: process.env.VUE_APP_OAUTH_URL,
    devHost : config.publicPath,
    api     : devHost ? `${apiUrl}/api/v1/` : `${apiUrl}/api/v1/`,
    apiV2   : `${apiUrl}/api/v2/`,
    publicV2: `${apiUrl}/api/v2/public/`,
    apiOff  : devHost ? `${apiUrl}/api/v1/offline/` : `${apiUrl}/api/v1/offline/`,
    s3Host  : 'https://cdn.appfacilita.com/',
    apiStage: 'https://api.facilitaapp.com/api/',
    apiMicro:  `${apiUrlMicro}/api/`,
    gtmID: 'GTM-5HRQXZS',
    pusherKey: 'b34088924a245727d19e',
    pusherCluster: 'mt1',
    environment: process.env.NODE_ENV,
    apiUrl
}
